module.exports = __webpack_public_path__ + "images/reopen-project-1c42901fb39e4bbbdbd197192c08dbfb.svg";